module.exports = __webpack_public_path__ + "img/04-round-not-convex-1-base.5f61fbb3.svg";